<template>
    <div>
        <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
            <!-- <div class="btn-toolbar dropdown">
                <router-link :to="{name : 'index', params: { page: 'cms' }}" class="btn btn-primary btn-sm mr-2 dropdown-toggle" >
                    <span class="fa fa-plus mr-2"></span>New Task
                </router-link>
            </div>
            <div class="btn-group">
                <button type="button" class="btn btn-sm btn-outline-primary">Share</button>
                <button type="button" class="btn btn-sm btn-outline-primary">Export</button>
            </div> -->
        </div>
        <div class="row justify-content-md-center">
            <div class="col-12 col-sm-6 col-xl-4 mb-4">
                <div class="card border-light shadow-sm">
                    <div class="card-body">
                        <div class="row d-block d-xl-flex align-items-center">
                            <div class="col-12 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">
                                <div class="icon icon-shape icon-md icon-shape-blue rounded mr-4 mr-sm-0"><span class="fa fa-user"></span></div>
                                <div class="d-sm-none">
                                    <h2 class="h5">Customers</h2>
                                    <h3 class="mb-1">345,678</h3>
                                </div>
                            </div>
                            <div class="col-12 col-xl-7 px-xl-0">
                                <div class="d-none d-sm-block">
                                    <h2 class="h5"><router-link :to="{name: 'index', params: { page: 'users' }}">Customers </router-link></h2>
                                    <h3 class="mb-1">{{alluser.count}} </h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-xl-4 mb-4">
                <div class="card border-light shadow-sm">
                    <div class="card-body">
                        <div class="row d-block d-xl-flex align-items-center">
                            <div class="col-12 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">
                                <div class="icon icon-shape icon-md icon-shape-secondary rounded mr-4"><span class="fa fa-sliders"></span></div>
                                <div class="d-sm-none">
                                    <h2 class="h5">Category</h2>
                                    <h3 class="mb-1">$43,594</h3>
                                </div>
                            </div>
                            <div class="col-12 col-xl-7 px-xl-0">
                                <div class="d-none d-sm-block">
                                    <h2 class="h5"> <router-link :to="{name: 'index', params: { page: 'category' }}">Category</router-link> </h2>
                                    <h3 class="mb-1">{{allCategories.count}}</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-xl-4 mb-4">
                <div class="card border-light shadow-sm">
                    <div class="card-body">
                        <div class="row d-block d-xl-flex align-items-center">
                            <div class="col-12 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">
                                <div class="icon icon-shape icon-md icon-shape-blue rounded mr-4 mr-sm-0"><span class="fa fa-product-hunt"></span></div>
                                <div class="d-sm-none">
                                    <h2 class="h5"><router-link :to="{name: 'index', params: { page: 'users' }}">Customers </router-link> </h2>
                                    <h3 class="mb-1">345,678</h3>
                                </div>
                            </div>
                            <div class="col-12 col-xl-7 px-xl-0">
                                <div class="d-none d-sm-block">
                                    <h2 class="h5"> <router-link :to="{name: 'index', params: { page: 'product' }}">Product</router-link> </h2>
                                    <h3 class="mb-1">{{allProducts.length}} </h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-xl-8 mb-4">
                <div class="row">
                    <div class="col-12 mb-4">
                        <div class="card border-light shadow-sm">
                            <div class="card-header">
                                <div class="row align-items-center">
                                    <div class="col">
                                        <h2 class="h5">Latest Order</h2>
                                    </div>
                                    <div class="col text-right">
                                        <router-link :to="{name: 'index', params: { page: 'Order' }}" class="btn btn-sm btn-secondary">See all</router-link>
                                    </div>
                                </div>
                            </div>
                            <div class="table-responsive">
                                <table class="table align-items-center table-flush">
                                    <thead class="thead-light">
                                        <tr>
                                            <th scope="col">Order By</th>
                                            <th scope="col">Product</th>
                                            <th scope="col">Price</th>
                                            <th scope="col">Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(Order,key) in allData.data" :key="key">
                                        <th >
                                         {{Order.userdata.username}}
                                        </th>
                                            <td>
                                              {{Order.paymenttype}}
                                            </td>
                                            <td>
                                               INR {{Order.total}}
                                            </td>
                                            <td class="text-success">
                                                {{Order.payment_status}}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-xl-4 mb-4">
                <div class="col-12 mb-4">
                    <div class="card border-light shadow-sm">
                        <div class="card-body d-flex flex-row align-items-center flex-0 border-bottom">
                            <div class="d-block">
                                <div class="h6 font-weight-normal text-gray mb-2">Total orders</div>
                               
                              
                            </div>
                            <div class="d-block ml-auto">
                                 <h2 class="h3"> {{allData.count}} </h2>
                            </div>
                        </div>
                       
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
export default {
    components: {},
    props: [
        "page", "action", "id"
    ],
    data() {
        return {
            showModal: false,
            isEditor: true,
            q: '',
            orderStatus: 'complete',
            loading: false,
            allData: [],
            alluser: [],
            allProducts: [],
            editSEO: false,
            defaultSEO: true,
            pageList: [],
            allCategories: []
           
        }
    },
    methods: {
        allDatas(status) {
            this.orderStatus = status
            // alert(status)
            var ev = this
            axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'api.php',
                data: {
                    type: 'getAllOrderAdmin',
                    status: status
                }
            }).then(function (response) {
                console.log(response);
                var data = response.data;
                ev.allData = data
            })
        },
        allusers(){
            var ev = this
            axios({
                    method: 'POST',
                    url: this.$root.URL_ROOT + 'api.php',
                    data: {
                        type: 'site_user',
                    }
                }).then(function (response) {
                var data = response.data;
                ev.alluser = data
                })
        },
         allCategory() {
            var ev = this
            axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'api.php?type=getCategory',
            }).then(function (response) {
                var data = response.data;
                ev.allCategories = data
            })
        },
         allProduct() {
             var ev = this
            axios({
                method: 'POST',
                url: this.$root.URL_ROOT+'api.php?type=getProduct',
            }).then(function (response) {
                var data = response.data;
                ev.allProducts = data.product;
            })
        },
    },
    mounted() {
        // this.getDetail();
        // this.getUnderof();
        this.allProduct()
        this.allDatas('complete')
        this.allusers()
        this.allCategory()
    },
   
}
</script>

